type Func<A extends unknown[], B> = (...args: A) => B;

export function pipe<A extends unknown[], B>(fn1: Func<A, B>): Func<A, B>;
export function pipe<A extends unknown[], B, C>(
  fn1: Func<A, B>,
  fn2: Func<[B], C>,
): Func<A, C>;
export function pipe<A extends unknown[], B, C, D>(
  fn1: Func<A, B>,
  fn2: Func<[B], C>,
  fn3: Func<[C], D>,
): Func<A, D>;
export function pipe<A extends unknown[], B, C, D, E>(
  fn1: Func<A, B>,
  fn2: Func<[B], C>,
  fn3: Func<[C], D>,
  fn4: Func<[D], E>,
): Func<A, E>;
export function pipe<A extends unknown[], B, C, D, E, F>(
  fn1: Func<A, B>,
  fn2: Func<[B], C>,
  fn3: Func<[C], D>,
  fn4: Func<[D], E>,
  fn5: Func<[E], F>,
): Func<A, F>;
export function pipe<A extends unknown[], B, C, D, E, F, G>(
  fn1: Func<A, B>,
  fn2: Func<[B], C>,
  fn3: Func<[C], D>,
  fn4: Func<[D], E>,
  fn5: Func<[E], F>,
  fn6: Func<[F], G>,
): Func<A, G>;

// Fallback function signature handling unknown number of arguments
export function pipe(...fns: Array<Func<unknown[], unknown>>) {
  return (...args: unknown[]) =>
    fns.reduce((value, fn, i) => [fn(...(i === 0 ? args : value))], args)[0];
}
